"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMetricDefinitionToComponentConfig = void 0;
function convertMetricDefinitionToComponentConfig(metricDefinition) {
    const queryRequest = {
        usage: 'DASHBOARD',
        name: metricDefinition.displayName,
        resultFilters: [],
        sortDescending: false,
    };
    const queryBased = metricDefinition.queryBased;
    if (queryBased) {
        queryRequest.type = queryBased.queryType;
        queryRequest.attributeColumns = [];
        queryRequest.valueColumns = queryBased.valueColumns;
        queryRequest.sourceFilters = queryBased.sourceFilters;
        queryRequest.presetConfig = queryBased.presetConfig;
    }
    const componentConfig = {
        identifier: metricDefinition.identifier,
        type: 'METRIC',
        title: metricDefinition.displayName,
        queryRequest,
        options: {
            fullWidth: false
        }
    };
    if (queryBased && queryBased.fieldDisplays) {
        componentConfig.fieldDisplays = queryBased.fieldDisplays;
    }
    else {
        componentConfig.fieldDisplays = [];
        (queryRequest.valueColumns || [])
            .forEach((valueColumn) => {
            var _a;
            (_a = componentConfig.fieldDisplays) === null || _a === void 0 ? void 0 : _a.push({
                field: valueColumn,
                displayName: valueColumn,
                amountUnit: 'AMOUNT'
            });
        });
    }
    return componentConfig;
}
exports.convertMetricDefinitionToComponentConfig = convertMetricDefinitionToComponentConfig;
//# sourceMappingURL=report-dashboard-converters.js.map